<mat-card data-at-role-management-modal>
  <mat-card-title>{{ '+USER_ROLE_MANAGEMENT.MODAL_TITLE' | translate }}</mat-card-title>
  <ng-container *ngIf="invitationsLoaded$ | async; then loaded; else loading"></ng-container>

  <ng-template #loading>
    <app-panel-content class="flex flex-col gap-[8px]">
      <vi-loader
        main
        data-at-loader
        message="{{ '+GENERAL.LOADING_DATA' | translate }}"
        [isLoading]="true"
      ></vi-loader>
    </app-panel-content>
  </ng-template>
  <ng-template #loaded>
    <mat-card-content class="content-wrapper flex flex-col gap-[4px]">
      <form [formGroup]="roleManagementForm" class="flex flex-col">
        <div class="dropdown-wrapper">
          <app-panel [expandable]="true" [expanded]="false">
            <app-panel-header>
              <div class="flex flex-row gap-[8px] justify-between items-center">
                <div>{{ '+USER_ROLE_MANAGEMENT.ROLE_OPERATOR' | translate }}</div>
              </div>
            </app-panel-header>
            <app-panel-content class="flex flex-col justify-center items-start">
              <div class="email-input-wrapper">
                <input
                  gtm="onTextField"
                  gtmId="email-operator"
                  gtmAction="email"
                  gtmCategory="roleManagementModal"
                  [formControl]="roleManagementForm.controls.operator"
                  class="email-input"
                  placeholder="{{ '+USER_ROLE_MANAGEMENT.MAIL_PLACEHOLDER' | translate }}"
                  fieldTextContentTooltip
                />
                <mat-icon
                  gtm="onSelect"
                  gtmAction="Clear"
                  gtmCategory="roleManagementModal"
                  (click)="clearInput('operator')"
                  *ngIf="roleManagementForm.controls.operator.value"
                  class="email-input-clear-btn"
                  >cancel</mat-icon
                >
              </div>
            </app-panel-content>
          </app-panel>
        </div>
        <div class="dropdown-wrapper">
          <app-panel [expandable]="true" [expanded]="false">
            <app-panel-header>
              <div class="flex flex-row gap-[8px] justify-between items-center">
                <div>{{ '+USER_ROLE_MANAGEMENT.ROLE_SERVICE_CONTRACTOR' | translate }}</div>
              </div>
            </app-panel-header>
            <app-panel-content class="flex flex-col justify-center items-start">
              <div class="email-input-wrapper">
                <input
                  gtm="onTextField"
                  gtmId="email-serviceContractor"
                  gtmAction="email"
                  gtmCategory="roleManagementModal"
                  [formControl]="roleManagementForm.controls.serviceContractor"
                  class="email-input"
                  placeholder="{{ '+USER_ROLE_MANAGEMENT.MAIL_PLACEHOLDER' | translate }}"
                  fieldTextContentTooltip
                />
                <mat-icon
                  gtm="onSelect"
                  gtmAction="Clear"
                  gtmCategory="roleManagementModal"
                  (click)="clearInput('serviceContractor')"
                  *ngIf="roleManagementForm.controls.serviceContractor.value"
                  class="email-input-clear-btn"
                  >cancel</mat-icon
                >
              </div>
            </app-panel-content>
          </app-panel>
        </div>
      </form>
    </mat-card-content>
  </ng-template>

  <ng-container *ngIf="areDuplicatedEmails()">
    <div class="active-error-information">
      <mat-icon>error_outline</mat-icon>
      <span>{{ '+BUILDING_MANAGER.SAME_EMAIL_ERROR' | translate }}</span>
    </div>
  </ng-container>

  <mat-card-actions class="flex flex-row gap-[16px] justify-between items-center">
    <button
      data-at-role-management-close-btn
      mat-button
      gtm="onClose"
      gtmAction="Cancel"
      gtmCategory="roleManagementModal"
      color="primary"
      (click)="onClose()"
    >
      {{ '+USER_ROLE_MANAGEMENT.BTN_CANCEL' | translate }}
    </button>
    <button
      data-at-role-management-save-btn
      mat-raised-button
      gtm="onConfirm"
      gtmAction="Save Changes"
      gtmCategory="roleManagementModal"
      color="primary"
      *ngIf="invitationsLoaded$ | async"
      [disabled]="
        isSaveButtonDisabled() ||
        (!roleManagementForm.controls.operator.dirty &&
          !roleManagementForm.controls.serviceContractor.dirty)
      "
      (click)="saveChanges()"
    >
      {{ '+USER_ROLE_MANAGEMENT.BTN_SAVE_CHANGES' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
